import { ApolloLink } from "./ApolloLink.js";
export var execute = ApolloLink.execute;
//# sourceMappingURL=execute.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/execute.js
// module id = 1494
// module chunks = 4